document.addEventListener("DOMContentLoaded", function () {
  //the button we're setting the destination on. bail if it isn't on the page
  const btn = document.getElementById("redirectBtn");
  if (!btn) return;

  //get all url params from the age gate page's own url
  const params = new URLSearchParams(window.location.search);

  //meta traffic is flagged explicitly with fb=1 on the incoming link.
  //the href check is a fallback for older links that don't carry the flag
  const isFb = params.get("fb") === "1" || window.location.href.includes("fb");

  //list of destination links to correspond with the page param value
  let redirectUrls;
  if (isFb) {
    redirectUrls = {
      //drinks goes to the product lander on try-mw, not straight to the store
      drinks: "https://try-mw.com/pages/mw-drinks",
      shop_all: "https://moonwlkr.com/fb_shop_all",
      sleep_1: "https://moonwlkr.com/fb_sleep_gummies",
      sleep_3: "https://moonwlkr.com/fb_sleep_gummies3",
      sleep_5: "https://moonwlkr.com/fb_sleep_gummies5",
      libido_1: "https://moonwlkr.com/fb_libido_gummies",
      libido_3: "https://moonwlkr.com/fb_libido_gummies3",
      libido_5: "https://moonwlkr.com/fb_libido_gummies5",
      collection_sleep: "https://moonwlkr.com/fb_sleep",
      collection_pain: "https://moonwlkr.com/fb_pain",
      collection_anxiety: "https://moonwlkr.com/fb_anxiety",
      collection_libido: "https://moonwlkr.com/fb_libido",
      collection_potency: "https://moonwlkr.com/fb_potency",
      collection_energy: "https://moonwlkr.com/fb_energy",
    };
  } else {
    redirectUrls = {
      //same lander either way, meta and non-meta share this one
      drinks: "https://try-mw.com/pages/mw-drinks",
      shop_all: "https://moonwlkr.com/collections/all",
      sleep_1: "https://moonwlkr.com/cart/47135963611386:1",
      sleep_3:
        "https://moonwlkr.com/cart/47135963644154:1,47135963611386:1?&discount=SLEEP-LP-2-1",
      sleep_5:
        "https://moonwlkr.com/cart/47135963644154:1,47135965380858:1?&discount=SLEEP-LP-3-2,sleep3for2shipping",
      libido_1: "https://moonwlkr.com/cart/46835814138106:1",
      libido_3:
        "https://moonwlkr.com/cart/47168570851578:1,47168570884346:1?&discount=LIBIDO-LP-2-1",
      libido_5:
        "https://moonwlkr.com/cart/47168570917114:1,47168570884346:1?&discount=LIBIDO-LP-3-2,buy3get2shipping",
      collection_sleep: "https://moonwlkr.com/collections/sleep",
      collection_pain: "https://moonwlkr.com/collections/pain",
      collection_anxiety: "https://moonwlkr.com/collections/anxiety",
      collection_libido:
        "https://moonwlkr.com/products/libido-gummies-passion-berry",
      collection_potency: "https://moonwlkr.com/collections/high-potency",
      collection_energy: "https://moonwlkr.com/collections/energy",
    };
  }

  //which destination the incoming link asked for
  const pageParam = params.get("page");
  console.log("params:", window.location.search);

  //if there's a valid page param, use its matching destination.
  //if not, fall back to the site root, meta-specific if we know it's meta
  let dest;
  if (pageParam && redirectUrls[pageParam]) {
    dest = redirectUrls[pageParam];
  } else {
    dest = isFb ? "https://moonwlkr.com/fb" : "https://moonwlkr.com";
  }

  const url = new URL(dest);

  //carry every tracking param through to the destination (gclid, fbclid, utms).
  //page is gate plumbing so it gets dropped. fb stays so the next hop knows the source
  params.forEach(function (v, k) {
    if (v && k !== "page") url.searchParams.set(k, v);
  });

  //flag that this visitor already cleared the age gate
  url.searchParams.set("age_verified", "true");

  btn.href = url.toString();
});